import { orderBy } from 'es-toolkit/compat';
import { PartsSortOptions } from 'interfaces';

interface Part {
  id: number;
  createdAt: string;
  position?: number | null;
}

export const sortBy = <T extends Part>(parts: T[], by: PartsSortOptions): T[] => {
  switch (by) {
    case PartsSortOptions.ID_ASC:
      return orderBy(parts, 'id', ['asc']);
    case PartsSortOptions.ID_DESC:
      return orderBy(parts, 'id', ['desc']);
    case PartsSortOptions.CREATION_ASC:
      return orderBy(parts, 'createdAt', ['asc']);
    case PartsSortOptions.CREATION_DESC:
      return orderBy(parts, 'createdAt', ['desc']);
    case PartsSortOptions.POSITION_ASC:
      return orderBy(parts, 'position', ['asc']);
    case PartsSortOptions.POSITION_DESC:
      return orderBy(parts, 'position', ['desc']);
    default:
      return [];
  }
};
